module.exports = __webpack_public_path__ + "img/part6.1317748f.png";